import { collection, doc, getDoc, getDocs, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { getFirestoreInstance } from './firestore';
import type { Invite, Role } from '@gigdriver/domain';
import { fromFirestore } from './serde';

// Invite docs are keyed by lowercased email so re-inviting the same address
// overwrites rather than duplicates. Claimed (turned into a real OrgMember,
// then deleted) by the onUserCreated Cloud Function on signup — mirrors the
// existing roster email-link pattern (functions/src/linking.ts).
function inviteId(email: string): string {
  return email.trim().toLowerCase();
}

export async function createInvite(
  orgId: string,
  email: string,
  role: Role,
  invitedBy: string,
): Promise<void> {
  const id = inviteId(email);
  const inviteRef = doc(getFirestoreInstance(), 'organizations', orgId, 'invites', id);
  await setDoc(inviteRef, {
    email: id,
    role,
    invitedBy,
    createdAt: serverTimestamp(),
  });
}

export async function getOrgInvites(orgId: string): Promise<Invite[]> {
  const invitesRef = collection(getFirestoreInstance(), 'organizations', orgId, 'invites');
  const snapshot = await getDocs(invitesRef);
  return snapshot.docs.map(d => fromFirestore<Invite>(d.data()));
}

export async function getInvite(orgId: string, email: string): Promise<Invite | null> {
  const inviteRef = doc(getFirestoreInstance(), 'organizations', orgId, 'invites', inviteId(email));
  const docSnap = await getDoc(inviteRef);
  return docSnap.exists() ? fromFirestore<Invite>(docSnap.data()) : null;
}

export async function deleteInvite(orgId: string, email: string): Promise<void> {
  const inviteRef = doc(getFirestoreInstance(), 'organizations', orgId, 'invites', inviteId(email));
  await deleteDoc(inviteRef);
}
